import DOMPurify from 'dompurify'

/*
 HTMLをサニタイズする
 html: String
 config: Object
 */
export function sanitizeHTML (html, config = {}) {
  if (!html || typeof html !== 'string') {
    return ''
  }

  const defaultConfig = {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
    ALLOWED_URI_REGEXP: /^$/
  }

  const sanitizeConfig = { ...defaultConfig, ...config }

  return DOMPurify.sanitize(html, sanitizeConfig)
}

/*
  配列の特定プロパティをサニタイズする
  array: Array
  properties: Array
  config: Object
  */
export function sanitizeArray (array, properties = [], config = {}) {
  if (!Array.isArray(array)) {
    return array
  }

  return array.map(item => {
    const sanitizedItem = { ...item }
    properties.forEach(prop => {
      if (sanitizedItem[prop] && typeof sanitizedItem[prop] === 'string') {
        sanitizedItem[prop] = sanitizeHTML(sanitizedItem[prop], config)
      }
    })
    return sanitizedItem
  })
}
